// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/ai_posture.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/ai_posture.proto.
 */
export const file_inventory_v1_ai_posture: GenFile = /*@__PURE__*/
  fileDesc("Ch1pbnZlbnRvcnkvdjEvYWlfcG9zdHVyZS5wcm90bxIMaW52ZW50b3J5LnYxIkQKEE1vZGVsUHJvdmlkZXJSZWYSEgoKY29tcGFueV9pZBgBIAEoCRIMCgRuYW1lGAIgASgJEg4KBmRvbWFpbhgDIAEoCSKXAgoQQ29tcGFueUFJUHJvZmlsZRIoCgdwb3N0dXJlGAEgASgOMhcuaW52ZW50b3J5LnYxLkFJUG9zdHVyZRIwCgxjYXBhYmlsaXRpZXMYAiADKA4yGi5pbnZlbnRvcnkudjEuQUlDYXBhYmlsaXR5EjcKD21vZGVsX3Byb3ZpZGVycxgDIAMoCzIeLmludmVudG9yeS52MS5Nb2RlbFByb3ZpZGVyUmVmEhsKDnBvc3R1cmVfcmVhc29uGAQgASgJSACIAQESIwoWYWlfcG9zdHVyZV9kZXNjcmlwdGlvbhgFIAEoCUgBiAEBQhEKD19wb3N0dXJlX3JlYXNvbkIZChdfYWlfcG9zdHVyZV9kZXNjcmlwdGlvbiqTAQoJQUlQb3N0dXJlEhoKFkFJX1BPU1RVUkVfVU5TUEVDSUZJRUQQABIdChlBSV9QT1NUVVJFX01PREVMX1BST1ZJREVSEAESGAoUQUlfUE9TVFVSRV9BSV9OQVRJVkUQAhIaChZBSV9QT1NUVVJFX0VNQkVEREVEX0FJEAMSFQoRQUlfUE9TVFVSRV9OT05fQUkQBCqkAwoMQUlDYXBhYmlsaXR5Eh0KGUFJX0NBUEFCSUxJVFlfVU5TUEVDSUZJRUQQABIiCh5BSV9DQVBBQklMSVRZX0FVVE9OT01PVVNfQUdFTlQQARIlCiFBSV9DQVBBQklMSVRZX1NDSEVEVUxFRF9FWEVDVVRJT04QAhIgChxBSV9DQVBBQklMSVRZX0NPREVfRVhFQ1VUSU9OEAMSHAoYQUlfQ0FQQUJJTElUWV9XRUJfQUNDRVNTEAQSKgomQUlfQ0FQQUJJTElUWV9DT01QVVRFUl9CUk9XU0VSX0NPTlRST0wQBRIdChlBSV9DQVBBQklMSVRZX0RBVEFfQUNDRVNTEAYSKQolQUlfQ0FQQUJJTElUWV9FWFRFUk5BTF9TWVNURU1fQUNUSU9OUxAHEhUKEUFJX0NBUEFCSUxJVFlfTUNQEAgSIwofQUlfQ0FQQUJJTElUWV9QRVJTSVNURU5UX01FTU9SWRAJEh8KG0FJX0NBUEFCSUxJVFlfR0VORVJBVElWRV9BSRAKEhcKE0FJX0NBUEFCSUxJVFlfT1RIRVIQC0K2AQoQY29tLmludmVudG9yeS52MUIOQWlQb3N0dXJlUHJvdG9QAVpBZ2l0aHViLmNvbS9sZW1hLmFpL2xlbW1hdGEvYXBpL3Byb3RvL2dlbi9pbnZlbnRvcnkvdjE7aW52ZW50b3J5djGiAgNJWFiqAgxJbnZlbnRvcnkuVjHKAgxJbnZlbnRvcnlcVjHiAhhJbnZlbnRvcnlcVjFcR1BCTWV0YWRhdGHqAg1JbnZlbnRvcnk6OlYxYgZwcm90bzM");

/**
 * @generated from message inventory.v1.ModelProviderRef
 */
export type ModelProviderRef = Message<"inventory.v1.ModelProviderRef"> & {
  /**
   * global catalog Company.ID of the provider
   *
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * for the logo
   *
   * @generated from field: string domain = 3;
   */
  domain: string;
};

/**
 * Describes the message inventory.v1.ModelProviderRef.
 * Use `create(ModelProviderRefSchema)` to create a new message.
 */
export const ModelProviderRefSchema: GenMessage<ModelProviderRef> = /*@__PURE__*/
  messageDesc(file_inventory_v1_ai_posture, 0);

/**
 * CompanyAIProfile is a transport shape, not a mirror of the schema: posture and
 * posture_reason come from `companies` columns, capabilities from the
 * company_ai_capabilities join table, and model_providers from the
 * relationship-filtered company_subprocessors join.
 *
 * Absent entirely when the vendor has no AI classification.
 *
 * @generated from message inventory.v1.CompanyAIProfile
 */
export type CompanyAIProfile = Message<"inventory.v1.CompanyAIProfile"> & {
  /**
   * @generated from field: inventory.v1.AIPosture posture = 1;
   */
  posture: AIPosture;

  /**
   * @generated from field: repeated inventory.v1.AICapability capabilities = 2;
   */
  capabilities: AICapability[];

  /**
   * Providers powering THIS vendor's AI: fourth parties on the model-provider
   * list whose relationship is flagged company_subprocessors.is_model_provider.
   * Empty when posture == MODEL_PROVIDER.
   *
   * @generated from field: repeated inventory.v1.ModelProviderRef model_providers = 3;
   */
  modelProviders: ModelProviderRef[];

  /**
   * Mirrors companies.ai_posture_reason.
   *
   * @generated from field: optional string posture_reason = 4;
   */
  postureReason?: string;

  /**
   * @generated from field: optional string ai_posture_description = 5;
   */
  aiPostureDescription?: string;
};

/**
 * Describes the message inventory.v1.CompanyAIProfile.
 * Use `create(CompanyAIProfileSchema)` to create a new message.
 */
export const CompanyAIProfileSchema: GenMessage<CompanyAIProfile> = /*@__PURE__*/
  messageDesc(file_inventory_v1_ai_posture, 1);

/**
 * @generated from enum inventory.v1.AIPosture
 */
export enum AIPosture {
  /**
   * no classification — the FE folds this with NON_AI into "AI not detected"
   *
   * @generated from enum value: AI_POSTURE_UNSPECIFIED = 0;
   */
  AI_POSTURE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AI_POSTURE_MODEL_PROVIDER = 1;
   */
  AI_POSTURE_MODEL_PROVIDER = 1,

  /**
   * @generated from enum value: AI_POSTURE_AI_NATIVE = 2;
   */
  AI_POSTURE_AI_NATIVE = 2,

  /**
   * @generated from enum value: AI_POSTURE_EMBEDDED_AI = 3;
   */
  AI_POSTURE_EMBEDDED_AI = 3,

  /**
   * @generated from enum value: AI_POSTURE_NON_AI = 4;
   */
  AI_POSTURE_NON_AI = 4,
}

/**
 * Describes the enum inventory.v1.AIPosture.
 */
export const AIPostureSchema: GenEnum<AIPosture> = /*@__PURE__*/
  enumDesc(file_inventory_v1_ai_posture, 0);

/**
 * @generated from enum inventory.v1.AICapability
 */
export enum AICapability {
  /**
   * @generated from enum value: AI_CAPABILITY_UNSPECIFIED = 0;
   */
  AI_CAPABILITY_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AI_CAPABILITY_AUTONOMOUS_AGENT = 1;
   */
  AI_CAPABILITY_AUTONOMOUS_AGENT = 1,

  /**
   * @generated from enum value: AI_CAPABILITY_SCHEDULED_EXECUTION = 2;
   */
  AI_CAPABILITY_SCHEDULED_EXECUTION = 2,

  /**
   * @generated from enum value: AI_CAPABILITY_CODE_EXECUTION = 3;
   */
  AI_CAPABILITY_CODE_EXECUTION = 3,

  /**
   * @generated from enum value: AI_CAPABILITY_WEB_ACCESS = 4;
   */
  AI_CAPABILITY_WEB_ACCESS = 4,

  /**
   * @generated from enum value: AI_CAPABILITY_COMPUTER_BROWSER_CONTROL = 5;
   */
  AI_CAPABILITY_COMPUTER_BROWSER_CONTROL = 5,

  /**
   * @generated from enum value: AI_CAPABILITY_DATA_ACCESS = 6;
   */
  AI_CAPABILITY_DATA_ACCESS = 6,

  /**
   * @generated from enum value: AI_CAPABILITY_EXTERNAL_SYSTEM_ACTIONS = 7;
   */
  AI_CAPABILITY_EXTERNAL_SYSTEM_ACTIONS = 7,

  /**
   * @generated from enum value: AI_CAPABILITY_MCP = 8;
   */
  AI_CAPABILITY_MCP = 8,

  /**
   * @generated from enum value: AI_CAPABILITY_PERSISTENT_MEMORY = 9;
   */
  AI_CAPABILITY_PERSISTENT_MEMORY = 9,

  /**
   * @generated from enum value: AI_CAPABILITY_GENERATIVE_AI = 10;
   */
  AI_CAPABILITY_GENERATIVE_AI = 10,

  /**
   * shipped AI none of the others describes; set only when all others are absent
   *
   * @generated from enum value: AI_CAPABILITY_OTHER = 11;
   */
  AI_CAPABILITY_OTHER = 11,
}

/**
 * Describes the enum inventory.v1.AICapability.
 */
export const AICapabilitySchema: GenEnum<AICapability> = /*@__PURE__*/
  enumDesc(file_inventory_v1_ai_posture, 1);

